<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-12 pt-2 pb-3 pl-4">
          <h3><i class="fas fa-map-marked-alt"></i> Módulo de Visitas <small style="font-size: 18px;">| Follow-up</small></h3>
        </div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12">
          <div v-for="(card, index) in cards" :key="card.id" >
            <p>{{ card.boardColumn.board.nome }} -- {{ card.boardColumn.nome }}</p>
            <task-card
                  :task="card" :color="card.boardColumn.cor" :boardColumnId="card.boardColumn.id"
                  :boardPosition="card.boardColumn.position ? card.boardColumn.position : 0" :percentage="card.boardColumn.percentual"
                  :hoursUntilAlert="card.boardColumn.hoursUntilAlert" :index="index" :hasObservation="false"
                  @Open="showLead(card)"></task-card>
          </div>
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 text-center">
          <img src="/static/img/bg/world_re_768g.svg" style="width: 40%; opacity: 0.2"/>
        </div>
      </div>
    </div>
    <ModalCard ref="ModalCard" v-if="selectedCard" @hideModal="hideLead" :key="selectedCard"
      isVisita :visitaId="visitaId" @reloadBoardColumns="()=>{}" :boardColumns="[]" :cardId="selectedCard" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import TaskCard from '@/views/private/crm/components/TaskCard.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'

import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'

export default {
  name: 'FollowUp',
  mixins: [ActionsForm],
  components: {
    TaskCard,
    ModalCard
  },
  data () {
    return {
      visitaId: null,
      pessoa: null,
      cards: [],
      selectedCard: null
    }
  },
  async mounted () {
    Tools.MinimizedSidebar()
    const resp = await DeslocamentoRepository.GetActive()
    if (resp.data === '' || resp.data.visitas === null || resp.data.visitas.length === 0) {
      this.onBack()
      return
    }
    const visita = resp.data.visitas.find(v => v.dataCheckOut === null)
    if (visita === null) {
      this.onBack()
      return
    }
    this.visitaId = visita.id
    this.pessoa = visita.pessoa

    this.loadCards()
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Visitas' })
    },
    loadCoordinates (data) {
      this.data.latitudeFinal = data.latitude
      this.data.longitudeFinal = data.longitude
    },
    async loadCards () {
      const response = await CardRepository.SearchAllByDocument(this.pessoa.document)

      this.cards = response.data.content
    },
    showLead (card) {
      this.selectedCard = card.id
    },
    hideLead () {
      this.selectedCard = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/followup.vue